/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @description 用户登录信息日志
 */
import getMemberLoginLog, {
  GetMemberLoginLogParams,
} from "./getMemberLoginLog";

export class CuMemberLoginLogApi {
  constructor(
    public getMemberLoginLog: (
      params: GetMemberLoginLogParams,
      success?: ({
        data,
        ext,
        state,
        errors,
      }: {
        data: Array<member.MemberLoginLogResponse>;
        ext: ObjectMap;
        state: "SUCCESS" | "FAIL" | "EXCEPTION";
        errors?: Array<string>;
      }) => any,
      fail?: (error: string) => any
    ) => void
  ) {}
}

export default {
  getMemberLoginLog,
} as CuMemberLoginLogApi;
